/**
 * API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { RecalculateRecoveryCommand } from '../model/recalculateRecoveryCommand';
import { RecoveryDispatchModel } from '../model/recoveryDispatchModel';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class RecoveryAdminService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Gets recovery dispatch history for a user
     * Ledger rows for one user: status, attempts, and the scheduled/claimed/completed timestamps. Operator diagnostics, not a client surface.
     * @param userUid 
     * @param fromLocalDate 
     * @param toLocalDate 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminRecoveryAdminDispatchesGet(userUid?: string, fromLocalDate?: string, toLocalDate?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<RecoveryDispatchModel>>;
    public adminRecoveryAdminDispatchesGet(userUid?: string, fromLocalDate?: string, toLocalDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<RecoveryDispatchModel>>>;
    public adminRecoveryAdminDispatchesGet(userUid?: string, fromLocalDate?: string, toLocalDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<RecoveryDispatchModel>>>;
    public adminRecoveryAdminDispatchesGet(userUid?: string, fromLocalDate?: string, toLocalDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (userUid !== undefined && userUid !== null) {
            queryParameters = queryParameters.set('UserUid', <any>userUid);
        }
        if (fromLocalDate !== undefined && fromLocalDate !== null) {
            queryParameters = queryParameters.set('FromLocalDate', <any>fromLocalDate);
        }
        if (toLocalDate !== undefined && toLocalDate !== null) {
            queryParameters = queryParameters.set('ToLocalDate', <any>toLocalDate);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<RecoveryDispatchModel>>('get',`${this.basePath}/Admin/RecoveryAdmin/Dispatches`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Starts the GPI history fill
     * Enqueues a one-off job that calculates recovery results and GPI days for every recovery cohort client over the last 270 days. Returns the job id.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminRecoveryAdminGpiHistoryFillPost(observe?: 'body', reportProgress?: boolean): Observable<any>;
    public adminRecoveryAdminGpiHistoryFillPost(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public adminRecoveryAdminGpiHistoryFillPost(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public adminRecoveryAdminGpiHistoryFillPost(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('post',`${this.basePath}/Admin/RecoveryAdmin/GpiHistoryFill`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Forces a recovery recalculation
     * Marks an existing dispatch row due again, so the next tick recomputes it. Reuses the invalidation path rather than adding a second way in.
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public adminRecoveryAdminRecalculatePost(body?: RecalculateRecoveryCommand, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public adminRecoveryAdminRecalculatePost(body?: RecalculateRecoveryCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public adminRecoveryAdminRecalculatePost(body?: RecalculateRecoveryCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public adminRecoveryAdminRecalculatePost(body?: RecalculateRecoveryCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<number>('post',`${this.basePath}/Admin/RecoveryAdmin/Recalculate`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
